import {I18n} from 'aws-amplify/utils';
import {Button} from '@mantine/core';
import {AiOutlineTags} from 'react-icons/ai';
import {useMessagesSelection} from '../hooks/useMessagesSelection';
import {useState} from 'react';
import {TagMultipleDrawer} from '../drawers/TagMultipleDrawer';
import {update} from '../services/MessagesService';

export const TagMultipleButton = () => {
    const {selection, handleClearSelection} = useMessagesSelection();
    const recordIds = Object.keys(selection);
    const disabled = recordIds.length === 0;
    const [drawerOpened, setDrawerOpened] = useState(false);

    const handleTagSubmit = async (tagId: string) => {
        for (const id of recordIds) {
            const message = selection[id];
            const existingTagIds = message.tagIds || [];
            if (!existingTagIds.includes(tagId)) {
                await update(id, {tagIds: [...existingTagIds, tagId]});
            }
        }
        handleClearSelection();
    };

    return (
        <>
            <Button
                variant="filled"
                leftSection={<AiOutlineTags/>}
                size="sm"
                disabled={disabled}
                onClick={() => setDrawerOpened(true)}
            >
                {I18n.get('Tag Multiple')}
            </Button>
            <TagMultipleDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
                onSubmit={handleTagSubmit}
            />
        </>
    );
};
